import * as React from 'react';

function ManageApplication(props) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={24} height={24} viewBox='0 0 24 24' {...props}>
      <g id='Group_72' data-name='Group 72' transform='translate(-620 228)'>
        <rect
          id='Rectangle_16'
          data-name='Rectangle 16'
          width={24}
          height={24}
          transform='translate(620 -228)'
          fill='#fff'
        />
        <path
          id='Path_25'
          data-name='Path 25'
          d='M19.541,9.727H12.634L10.907,8H5.727A1.719,1.719,0,0,0,4.009,9.727L4,20.088a1.726,1.726,0,0,0,1.727,1.727H19.541a1.726,1.726,0,0,0,1.727-1.727V11.454A1.726,1.726,0,0,0,19.541,9.727Zm0,10.361H5.727V11.454H19.541Z'
          transform='translate(619.5 -230.5)'
          fill='#003ec4'
          stroke='#fff'
          strokeWidth={0.5}
        />
      </g>
    </svg>
  );
}
export default ManageApplication;
